import { useMutation } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'
import { useInvalidateAfterFeatureChange } from 'features/customers/hooks/useInvalidateAfterFeatureChange'

import { useAddNotification } from 'hooks/useAddNotification'
import { del } from 'utils/http'

export const useCustomerFeaturesReset = () => {
  const customerId = useCustomerId()
  const addNotification = useAddNotification()
  const invalidate = useInvalidateAfterFeatureChange()

  // As the save path does. The server names the plan when nobody typed a reason.
  const resetFeatures = (note?: string) =>
    del(`/management/customers/${customerId}/features/custom`, undefined, { query: note ? { note } : undefined })

  return useMutation({
    mutationFn: resetFeatures,
    onSuccess: async () => {
      await invalidate()

      addNotification('Features reset successfully', 'success')
    },
    onError: () => {
      addNotification('Failed to reset features', 'error')
    },
  })
}
